import React from 'react';
import './fiscal-auth.css';
import Loader from './AuthLoader';
import { URL } from '../variables';

class SelectFaculdade extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faculdades: [],
      faculdade_select: 'tete',
      loading: false,
      msgErro: '',
      redirect: false
    }
  }

  change_faculdade(event) {
    this.setState({ faculdade_select: event.target.value });

  }

  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to={'/'+this.state.faculdade_select.slug} />
  //   }
  // }

  get_faculdades() {
    fetch(`${URL}api/fiscal/get_faculdades`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        // 'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false });
        }
        else {
          let selected = '';
          if (resp.faculdades.length > 0) {

            selected = resp.faculdades[0].slug;
          }
          this.setState({ faculdades: resp.faculdades, loading: false, msgErro: '', faculdade_select: selected });
          // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor', refresh: false, loadingMore: false });

      }

    })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', refresh: false, loadingMore: false });
      });
  }

  componentDidMount() {
    this.setState({ loading: true, msgErro: '' });
    this.get_faculdades();
  }






  render() {
    console.log(this.state.faculdade_select)
    return (
      <div className="fiscal-auth-page">
        {this.state.loading && <Loader fullScreen title={"Carregando dados. Por favor, aguarde."} description={"Aguarde enquanto preparamos seu ambiente."} />}
        {this.state.loading == false && <div id="app" className="fiscal-select-page">
          <header className="fiscal-select-header">
            <a className="logo"><img src={require('../assets/images/logo-ontest.png')} height="58" alt="logo" /></a>
          </header>

          <main className="fiscal-select-main">
            <section className="fiscal-select-card">
              <div className="fiscal-select-copy">
                <span>{"Processos de prova"}</span>
                <h1>{"Escolha o processo que você vai fiscalizar"}</h1>
                <p>{"Selecione a instituição ou processo seletivo para acessar o ambiente de autenticação fiscal."}</p>
              </div>

              <div className="fiscal-select-list">
                {this.state.faculdades.map((item, id) => (
                  <a key={id} href={'/' + item.slug + '/login'} className="fiscal-select-item">
                    <div className="fiscal-select-logo">
                      <img src={item.logo} alt="logo" />
                    </div>
                    <div className="fiscal-select-info">
                      <strong>{item.name}</strong>
                      <span>{"Acessar sala de fiscalização"}</span>
                    </div>
                    <div className="fiscal-select-action">
                      <span>{"Acessar"}</span>
                      <i className="mdi mdi-arrow-right"></i>
                    </div>
                  </a>
                ))}
                {this.state.faculdades.length == 0 && <div className="fiscal-select-empty">
                  <i className="mdi mdi-clipboard-alert-outline"></i>
                  <p>{"Nenhum processo disponível no momento."}</p>
                </div>
                }
              </div>
            </section>
          </main>
        </div>}
      </div>
    );
  }


}

export default SelectFaculdade;
